import { render } from "./index.vue?vue&type=template&id=adf8ddce"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=adf8ddce&lang=scss"
script.render = render

export default script